import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const iconStyles = {
  lineHeight:"normal",
  textIndent:0,
  textAlign:"start",
  textDecorationLine:"none",
  textDecorationStyle:"solid",
  textDecorationColor: "#000",
  textTransform:"none",
  blockProgression:"tb",
  isolation:"auto",
  mixBlendMode:"normal"
};

const CalendarIcon = (props) => (
  <SvgIcon {...props}>
     <path style={iconStyles} d="M 12 0 C 10.906937 0 10 0.9069372 10 2 L 10 4 L 4 4 C 3.4777778 4 2.9453899 4.1913289 2.5683594 4.5683594 C 2.1913289 4.9453899 2 5.4777778 2 6 L 2 46 C 2 46.522222 2.1913289 47.05461 2.5683594 47.431641 C 2.9453899 47.808671 3.4777778 48 4 48 L 46 48 C 46.522222 48 47.05461 47.808671 47.431641 47.431641 C 47.808671 47.05461 48 46.522222 48 46 L 48 6 C 48 5.4777778 47.808671 4.9453899 47.431641 4.5683594 C 47.05461 4.1913289 46.522222 4 46 4 L 40 4 L 40 2 C 40 0.9069372 39.093063 0 38 0 L 36 0 C 34.906937 0 34 0.9069372 34 2 L 34 4 L 16 4 L 16 2 C 16 0.9069372 15.093063 0 14 0 L 12 0 z M 12 2 L 14 2 L 14 8 L 12 8 L 12 2 z M 36 2 L 38 2 L 38 8 L 36 8 L 36 2 z M 4 6 L 10 6 L 10 8 C 10 9.0930628 10.906937 10 12 10 L 14 10 C 15.093063 10 16 9.0930628 16 8 L 16 6 L 34 6 L 34 8 C 34 9.0930628 34.906937 10 36 10 L 38 10 C 39.093063 10 40 9.0930628 40 8 L 40 6 L 46 6 L 46 13 L 4 13 L 4 6 z M 4 15 L 46 15 L 46 46 L 4 46 L 4 15 z M 10 19 L 10 20 L 10 42 L 30 42 L 40 42 L 40 19 L 10 19 z M 12 21 L 17 21 L 17 26 L 12 26 L 12 21 z M 19 21 L 24 21 L 24 26 L 19 26 L 19 21 z M 26 21 L 31 21 L 31 26 L 26 26 L 26 21 z M 33 21 L 38 21 L 38 26 L 33 26 L 33 21 z M 12 28 L 17 28 L 17 33 L 12 33 L 12 28 z M 19 28 L 24 28 L 24 33 L 19 33 L 19 28 z M 26 28 L 31 28 L 31 33 L 26 33 L 26 28 z M 33 28 L 38 28 L 38 33 L 33 33 L 33 28 z M 12 35 L 17 35 L 17 40 L 12 40 L 12 35 z M 19 35 L 24 35 L 24 40 L 19 40 L 19 35 z M 26 35 L 31 35 L 31 40 L 30 40 L 26 40 L 26 35 z M 33 35 L 38 35 L 38 40 L 33 40 L 33 35 z"/>
  </SvgIcon>
);

export default CalendarIcon



// WEBPACK FOOTER //
// ./src/core/components/CalendarIcon.js